import * as momentjs from 'moment';
import 'moment-timezone';
import axios from "axios";
import cookie from 'react-cookies';

import { IcCheckS, IcCloseRedS, IcInfoOrangeS, IcCheckBlackS, IcErrorS, IcClockS } from "../common/svg";


export function moment(x) {
	let m = momentjs(x);
	m.tz("Asia/Ho_Chi_Minh");
	return m;
}

export const Mode = {
    TRAVELER: 0, 
    OWNER: 1
}

export const viewModes = {
	LIST: 0,
	MAP: 1
}

export const genderMap = {
    0: "Chưa rõ",
    1: "Nam",
    2: "Nữ"
}

export const CarTransmission = {
    0: "Chưa rõ",
    1: "Số tự động",
    2: "Số sàn"
}

export const Transmission = {
	AUTO: 1,
	MANUAL: 2
}

export const CarFuel = {
    0: "Chưa rõ",
    1: "Xăng",
    2: "Dầu diesel",
    3: "Điện"
}

export const TripStatus = {
    1: "Đang chờ chủ xe duyệt",
    2: "Đang chờ đặt cọc",
    3: "Đang chờ đặt cọc",
    4: "Đã đặt cọc",
    5: "Đang cho thuê",
    20: "Chủ xe đã từ chối",
    21: "Chủ xe đã huỷ chuyến",
    22: "Chủ xe đã huỷ chuyến",
    23: "Khách thuê đã huỷ chuyến",
    24: "Khách thuê đã huỷ chuyến",
    25: "Chuyến đã kết thúc"
}

export const TOwnerTransactionType = {
    0: "",
    1: "Kết thúc chuyến đi",
    2: "Chủ xe hủy chuyến",
    3: "Khách thuê hủy chuyến",
    21: "Rút tiền",
    40: "Nạp tiền vào tài khoản",
    41: "Trừ tiền tài khoản"
}

export const CarStatus = {
    0: "Không xác định",
    1: "Chờ duyệt",
    2: "Đang hoạt động",
    3: "Đã bị từ chối",
    4: "Đã xoá",
    5: "Tạm ngưng hoạt động",
    6: "Dừng kinh doanh"
}

export const CarStatusColor = {
    0: "black",
    1: "warning",
    2: "success",
    3: "error",
    4: "error",
    5: "black",
    6: "error"
}

export const CarStatusIc = { 
    0: <IcClockS />,
    1: <IcInfoOrangeS />,
    2: <IcCheckS />,
    3: <IcErrorS />,
    4: <IcErrorS />,
    5: <IcClockS />,
    6: <IcErrorS />
}

export const ThemeMode = {
	DARK: "default",
	LIGHT: "light"
}

export const AddressType = {
	COMPANY: "Company",
	HOME: "home",
	OTHERS: ""
}

export const DriverLicenseStatus = {
	TDS_NULL: 0,
	TDS_QUICK_VERIFIED: 1,
	TDS_WAIT_MANUAL_VERIFIED: 2,
	TDS_FULL_VERIFIED: 3,
	TDS_INVALID: 11
}

export const getDriverLicenseStatus = (status) => {
	switch (status) {
		case 0: 
			return {
				ic: <IcCloseRedS />, 
                clg: "error",
				name: "Chưa xác thực",
				stt: "Chưa xác thực"
			}
		case 1: 
			return {
				ic: <IcCheckS />,
                clg: "success",
				name: "Đã xác thực",
				stt: "Đã xác thực"
			}
		case 2: 
			return {
				ic: <IcCheckS />,
                clg: "success",
				name: "Chờ xác thực",
				stt: "Đã xác thực"
			}
		case 3: 
			return {
				ic: <IcCheckS />,
                clg: "success",
				name: "Đã xác thực",
				stt: "Đã xác thực"
			}
		case 11: 
			return {
				ic: <IcCloseRedS />,
                clg: "error",
				name: "Xác thực thất bại",
				stt: "Chưa xác thực"
			}
        case 40: {
            return { 
                ic: <IcCheckS />,
                clg: "success",
                name: "GPLX sắp hết hạn",
                stt: "Đã xác thực"
            }
        }
        case 41: {
            return { 
                ic: <IcInfoOrangeS />,
                clg: "warning",
                name: "GPLX hết hạn",
                stt: "Đã xác thực"
            }
        }
	}

}

export const getHCMCityCoordinates = {
    address: 'Sài Gòn, Hồ Chí Minh, Việt Nam',
    lat: 10.8,
    lng: 106.7
}

export const coordinates = {
    HCM: {
        lat: 10.8,
        lng: 106.7
    },
    HN: {
        lat: 20.79753965,
        lng: 105.88674051
    }
}

export const getTripStatus = (status, needReview) => {
    if (status >= 25) {
        if (needReview) {
            return {
                class: "success",
                ic: <IcCheckS />,
                name: "Chưa đánh giá"
            }
        } else {
            return {
                class: "done",
                ic: <IcCheckBlackS />,
                name: "Đã kết thúc"
            }
        }
    } else if (status >= 23) {
        return {
            class: "error",
            ic: <IcErrorS />,
            name: "Khách thuê đã huỷ"
        }
    } else if (status >= 21) {
        return {
            class: "error",
            ic: <IcErrorS />,
            name: "Chủ xe đã huỷ"
        }
    } else if (status >= 20) {
        return {
            class: "error",
            ic: <IcErrorS />,
            name: "Chủ xe đã từ chối"
        }
    } else if (status >= 5) {
        return {
            class: "success",
            ic: <IcCheckS />,
            name: "Đang trong chuyến"
        }
    } else if (status >= 4) {
        return {
            class: "success",
            ic: <IcCheckS />,
            name: "Đã đặt cọc"
        }
    } else if (status >= 2) {
        return {
            class: "warning",
            ic: <IcInfoOrangeS />,
            name: "Chờ đặt cọc"
        }
    } else {
        return {
            class: "warning",
            ic: <IcInfoOrangeS />,
            name: "Chờ chủ xe duyệt"
        }
    }
}

export function getTripTime(trip) {
    if (trip.status >= 25) {
        return trip.return;
    } else if (trip.status >= 23) {
        return trip.timeCanceled;
    } else if (trip.status >= 21) {
        return trip.timeCanceled;
    } else if (trip.status >= 20) {
        return trip.timeCanceled;
    } else if (trip.status >= 5) {
        return trip.timePickup;
    } else if (trip.status >= 4) {
        return trip.timeDeposited;
    } else if (trip.status >= 2) {
        return trip.timeApproved;
    } else {
        return trip.timeBooked;
    }
}

export function formatPrice(price) {
    return Math.round(price / 1000) + "K";
}

export function arrayToString(data) {
    if (!data || data.length === 0) {
        return "";
    }
    var ret = "";
    for (var i = data.length - 1; i >= 0; --i) {
        if (ret === "") {
            ret = data[i];
        } else {
            ret += ";" + data[i];
        }
    }
    return ret;
}

export function arrayObjToString(data, key) {
    if (!data || data.length === 0) {
        return "";
    }
    var ret = "";
    for (var i = data.length - 1; i >= 0; --i) {
        if (ret === "") {
            ret = data[i][key];
        } else {
            ret += ";" + data[i][key];
        }
    }
    return ret;
}

export const carIconSmall = {
    path: 'M18.9 5c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L3 11v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8l-2.1-6zM6.5 15c-.8 0-1.5-.7-1.5-1.5S5.7 12 6.5 12s1.5.7 1.5 1.5S7.3 15 6.5 15zm11 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z',
    fillColor: '#00a550',
    fillOpacity: 1,
    scale: 0.75
};

export const carIcon = {
    path: 'M18.9 5c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L3 11v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8l-2.1-6zM6.5 15c-.8 0-1.5-.7-1.5-1.5S5.7 12 6.5 12s1.5.7 1.5 1.5S7.3 15 6.5 15zm11 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z',
    fillColor: '#00a550',
    fillOpacity: 1,
    scale: 1.5
};

export const notiType = {
    NTT_NULL: 0,
    NTT_ANNOUNCE: 1,
    NTT_BOOKING: 20,
    NTT_REQ: 80
}

export const stypes = {
    SD: 1,  //Self Drive
    WD: 2,  //With Driver
    CS: 4,  //Car Subscription
}

export const wdType = {
    WDT_NULL: 0,
    WDT_CITY_TOUR: 1,
    WDT_ONEWAY: 2,
    WDT_TWOWAY: 3,
}

export const getWdType = {
	0: "Không rõ", 
	1: "Có tài - Nội thành",
	2: "Có tài -  1 chiều", 
	3: "Có tài - 2 chiều"
}

export const otpMethod = {
    TOP_NULL: 0,
    TOP_FACEBOOK: 1,
    TOP_MIOTO: 2,
    TOP_SUPPORT: 20,
}

export const otpAction = {
    TOA_NULL: 0,
    TOA_VERIFY: 1,
    TOA_RECOVER_PASSWORD: 2,
    TOA_VERIFY_LOGIN: 4,
}

export const OtpBy = { 
    DEFAULT: 0,
    MESSAGE: 1,
    CALL: 3
}

export const InsBy = {
    1: 'MIC', 
    2: 'PJICO', 
    3: 'PVI', 
    4: 'VNI',
    5: 'VNI', //VNI PREMIUM
}

export const SearchTips = {
    TIP: 1,
    WARNING: 2,
    DANGER: 3
}

export const getTypeClg = (type) => {
    switch (type) {
		case 1: 
			return {
                clg: ""
			}
		case 2: 
			return {
                clg: "warning"
			}
        case 2: 
			return {
                clg: "warning"
			}
	
	}
}

export function getBookingTimes() {
	const bookingTimes = []
	for (var i = 0, j = 0; i < 1440; i = i + 30) {
       
		const time = i;
		const hour = (time - time % 60) / 60;
		const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
		const min = time % 60;
		const minLabel = min < 10 ? `0${min}` : `${min}`;
		bookingTimes.push({ id: j++, value: time, label: `${hourLabel}:${minLabel}` });
	}
	return bookingTimes
}

export const getBTimes = () => {
	const bookingTimes = []
	for (var i = 1; i < 13; i++) {
    
       if (i == 1 || i % 3 == 0) {
            const time = i;
            const label = time === 0 ? 'Tùy chỉnh' : `${time} tháng`

            bookingTimes.push({ id: i, value: time, label: `${label}` });
        }

	}
	return bookingTimes
}

export function buildMonthCalendar(start, end, priceDaily, instantDays, unavailDays, bookedDays, priceSpecifics, priceRepeat,
    priceRepeatEndDate, isLimitRepeatPrice, unavailsRepeat, unavailsRepeatEndDate, isLimitUnavailsRepeat, setting) {
    const days = [];
    const mapTripsMaxLevel = {};
    const _1dayInMSec = 24 * 3600000;
    var i, j;

    for (i = start.valueOf(); i <= end.valueOf(); i = i + _1dayInMSec) {
        const isToday = moment(i).isSame(moment(), 'day');
        const isWeekend = moment(i).isoWeekday() === 7;
        var isPast = moment(i).isBefore(moment(), 'day');
        var isOutside = moment(i).isBefore(start, 'day') || end.isBefore(moment(i), 'day');
        var isBooked = false;
        var bookedWidth;
        var bookedLeft;

        var isInstant = false;
        var isUnavail = false;
        var isUnavailRepeat = false;
        var price = priceDaily;
        var isPriceRepeat = false;

        var bookedTripId = "";
        var tripsReq = [];
        var tripsReqRet = [];

        for (j = 0; j < instantDays.length; ++j) {
            if (i === instantDays[j]) {
                isInstant = true;
                break;
            }
        }

        for (j = 0; j < unavailDays.length; ++j) {
            if (i === unavailDays[j].startTime && unavailDays[j].startTime === unavailDays[j].endTime ) {
                isUnavail = true;
                break;
            }
            for (let k = unavailDays[j].startTime; k <= unavailDays[j].endTime; k += 86400000) {
                if (i === k && unavailDays[j].startTime !== unavailDays[j].endTime ) {
                    isUnavail = true;
                    break;
                }
            }
        }

        for (j = 0; j < bookedDays.length; ++j) {
            if (i === bookedDays[j].ts) {
                const trip = bookedDays[j];
                bookedTripId = trip.tripId;

                isBooked = true;
                bookedWidth = 100;
                bookedLeft = 0;

                if (moment(trip.startTs).isSame(moment(trip.endTs), "day")) {
                    bookedWidth = (trip.endTs - trip.startTs) * 100 / _1dayInMSec
                    bookedLeft = 100 - (i + _1dayInMSec - trip.startTs) * 100 / _1dayInMSec
                } else if (moment(trip.endTs).isBetween(moment(i), moment(i + _1dayInMSec))) {
                    bookedWidth = (trip.endTs - i) * 100 / _1dayInMSec
                } else if (moment(trip.startTs).isBetween(moment(i), moment(i + _1dayInMSec))) {
                    bookedWidth = (i + _1dayInMSec - trip.startTs) * 100 / _1dayInMSec
                    bookedLeft = 100 - bookedWidth
                }
                break;
            }
        }

        for (j = 0; j < priceRepeat.length; ++j) {
            const weekday = priceRepeat[j];
            if (weekday.price > 0
                && moment(i).isoWeekday() === weekday.weekday
                && (!isLimitRepeatPrice || !priceRepeatEndDate || priceRepeatEndDate === 0 || i <= priceRepeatEndDate)) {
                price = weekday.price;
                isPriceRepeat = true;
                break;
            }
        }

        for (j = 0; j < priceSpecifics.length; ++j) {
            if (i === priceSpecifics[j].ts) {
                price = priceSpecifics[j].price
                break;
            }
        }

		
        for (j = 0; j < unavailsRepeat.length; ++j) {
            const weekday = unavailsRepeat[j];
            if (moment(i).isoWeekday() === weekday.weekday
                && weekday.unavail === true
                && (!isLimitUnavailsRepeat || !unavailsRepeatEndDate || unavailsRepeatEndDate === 0 || i <= unavailsRepeatEndDate)) {
                isUnavail = true;
                isUnavailRepeat = true;
                break;
            }
        }

        if (setting.waitApproves) {
            for (j = 0; j < setting.waitApproves.length; ++j) {
                tripsReq.push({ ...setting.waitApproves[j], isApproved: false });
            }
        }
        if (setting.waitDeposits) {
            for (j = 0; j < setting.waitDeposits.length; ++j) {
                tripsReq.push({ ...setting.waitDeposits[j], isApproved: true });
            }
        }
        tripsReq = tripsReq.sort(function (trip1, trip2) {
            return trip1.startTime - trip2.startTime;
        });

        for (j = 0; j < tripsReq.length; ++j) {
            const trip = tripsReq[j];
            if (moment(i).isSame(moment(trip.startTime).startOf("day"))
                || moment(i).isSame(moment(trip.endTime).startOf("day"))
                || moment(i).isBetween(moment(trip.startTime).startOf("day"), moment(trip.endTime).endOf("day"))) {

                const isStart = moment(i).isSame(moment(trip.startTime), "day");
                var width = 100;
                var left = 0;

                if (moment(trip.startTime).isSame(moment(trip.endTime), "day")) {
                    width = (trip.endTime - trip.startTime) * 100 / _1dayInMSec
                    left = 100 - (i + _1dayInMSec - trip.startTime) * 100 / _1dayInMSec
                } else if (moment(trip.endTime).isBetween(moment(i), moment(i + _1dayInMSec))) {
                    width = (trip.endTime - i) * 100 / _1dayInMSec
                } else if (moment(trip.startTime).isBetween(moment(i), moment(i + _1dayInMSec))) {
                    width = (i + _1dayInMSec - trip.startTime) * 100 / _1dayInMSec
                    left = 100 - width
                }

                tripsReqRet.push({
                    tripInfo: trip,
                    width: width,
                    left: left,
                    isStart: isStart
                });

                var level = 1;
                for (var k = 0; k < j; ++k) {
                    const stackedTrip = tripsReq[k];
                    if (trip.startTime <= stackedTrip.endTime) {
                        if (mapTripsMaxLevel[stackedTrip.tripId]) {
                            level = mapTripsMaxLevel[stackedTrip.tripId] + 1;
                        } else {
                            level = level + 1;
                        }
                    }
                }

                if (!mapTripsMaxLevel[trip.tripId] || level > mapTripsMaxLevel[trip.tripId]) {
                    mapTripsMaxLevel[trip.tripId] = level;
                }
            }
        }

        days.push({
            ts: i,
            isToday: isToday,
            isWeekend: isWeekend,
            isPast: isPast,
            isOutside: isOutside,
            isBooked: isBooked,
            bookedTripId: bookedTripId,
            bookedLeft: bookedLeft,
            bookedWidth: bookedWidth,
            isInstant: isInstant,
            isUnavail: isUnavail,
            isUnavailRepeat: isUnavailRepeat,
            price: price,
            isPriceRepeat: isPriceRepeat,
            tripsReq: tripsReqRet,
            mapTripsMaxLevel: mapTripsMaxLevel
        })
    }

    return days;
}

export const toAlias = (str) => {
    str = trim(str);
    let replaceChr = '-';
    let stripped_str = str;
    stripped_str = stripped_str.replace(/,/g, '');
    let viet = [];
    let i = 0;
    viet[i++] = ['a', "/á|à|ả|ã|ạ|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/g"];
    viet[i++] = ['o', "/ó|ò|ỏ|õ|ọ|ơ|ớ|ờ|ở|ỡ|ợ|ô|ố|ồ|ổ|ỗ|ộ/g"];
    viet[i++] = ['e', "/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/g"];
    viet[i++] = ['u', "/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/g"];
    viet[i++] = ['i', "/í|ì|ỉ|ĩ|ị/g"];
    viet[i++] = ['y', "/ý|ỳ|ỷ|ỹ|ỵ/g"];
    viet[i++] = ['d', "/đ/g"];
    for (let i = 0; i < viet.length; i++) {// eslint-disable-next-line
        stripped_str = stripped_str.replace(eval(viet[i][1]), viet[i][0]);// eslint-disable-next-line
        stripped_str = stripped_str.replace(eval(viet[i][1].toUpperCase().replace('G', 'g')), viet[i][0].toUpperCase());
    }
    if (replaceChr) {// eslint-disable-next-line
        return stripped_str.replace(/[\W]|_/g, replaceChr).replace(/\s/g, replaceChr).replace(/^\-+|\-+$/g, replaceChr);
    } else {
        return stripped_str;
    }
}

export const trim = (str) => {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

export const formatTitleInUrl = (title) => {
    if (title) return toAlias(trim(title.trim().toLowerCase()
        .split(" ").join("_")
        .split("?").join("")
        .split("&").join("")
        .split(",").join("")
        .split(".").join("")
        .split(";").join("")
        .split("/").join("")));
}

export function formatTitleGroupName(title) {
	return title.split("?").join("")
}

export function convertToDateTimeObj(time) {
    time = moment(time).valueOf();

    var days = Math.floor(time / (1000 * 60 * 60 * 24));
    if (days < 10) {
        days = "0" + days;
    }
    var hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if (hours < 10) {
        hours = "0" + hours;
    }
    var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    var seconds = Math.floor((time % (1000 * 60)) / 1000);
    if (seconds < 10) {
        seconds = "0" + seconds;
    }

    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    }
}

export function getCountDownTime(time) {
    time = moment(time).valueOf();
    var now = moment().valueOf();

    return time - now;
}

export function convertToDateTimeText(time) {
    time = moment(time).valueOf();
    if (time < 0) {
        return "Thời gian còn lại: Quá hạn"
    }

    var dateTimeObj = convertToDateTimeObj(time);
    return "Thời gian còn lại: " + (dateTimeObj.days > 0 ? (dateTimeObj.days + " ngày ") : "")
        + (dateTimeObj.hours > 0 ? (dateTimeObj.hours + " tiếng ") : "")
        + (dateTimeObj.minutes > 0 ? (dateTimeObj.minutes + " phút ") : "")
        + dateTimeObj.seconds + " giây"
}

export function convertToHourText(time) {
	
	// if (time === 24 || time === 48) {
	// 	time = Number.parseInt(time / 24)
	// 	return `${time} ngày`
	// }

	return `${time} tiếng`
}

export function formatSecondTime(secondTime) {
	const time = secondTime / 60;
	const hour = (time - time % 60) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;

	return `${hourLabel}:${minLabel}`
}

export function formatTime(secondTime) {

	const time = secondTime;

	const hour = (time - time % 60) / 60;
   
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;


	return `${hourLabel}:${minLabel}`
}


export const VNCitiesMap = [
    { key: "HoChiMinh", value: "TP Hồ Chí Minh" },
    { key: "HaNoi", value: "Hà Nội" },
    { key: "DaNang", value: "Đà Nẵng" },
    { key: "BinhDuong", value: "Bình Dương" },
    { key: "CanTho", value: "Cần Thơ" },
    { key: "DaLat", value: "Đà Lạt" },
    { key: "NhaTrang", value: "Nha Trang" },
    { key: "QuyNhon", value: "Quy Nhơn" },
    { key: "PhuQuoc", value: "Phú Quốc" },
    { key: "HaiPhong", value: "Hải Phòng" },
    { key: "VungTau", value: "Vũng Tàu" },
    { key: "Others", value: "Thành phố khác" },

    // { key: "AnGiang", value: "An Giang" },
    // { key: "BaRiaVungTau", value: "Bà Rịa - Vũng Tàu" },
    // { key: "BacGiang", value: "Bắc Giang" },
    // { key: "BacKan", value: "Bắc Kạn" },
    // { key: "BacLieu", value: "Bạc Liêu" },
    // { key: "BacNinh", value: "Bắc Ninh" },
    // { key: "BenTre", value: "Bến Tre" },
    // { key: "BinhDinh", value: "Bình Định" },
    // { key: "BinhPhuoc", value: "Bình Phước" },
    // { key: "BinhThuan", value: "Bình Thuận" },
    // { key: "CaMau", value: "Cà Mau" },
    // { key: "CaoBang", value: "Cao Bằng" },
    // { key: "DakLak", value: "Đắk Lắk" },
    // { key: "DakNong", value: "Đắk Nông" },
    // { key: "DienBien", value: "Điện Biên" },
    // { key: "DongNai", value: "Đồng Nai" },
    // { key: "DongThap", value: "Đồng Tháp" },
    // { key: "GiaLai", value: "Gia Lai" },
    // { key: "HaGiang", value: "Hà Giang" },
    // { key: "HaNam", value: "Hà Nam" },
    // { key: "HaTinh", value: "Hà Tĩnh" },
    // { key: "HaiDuong", value: "Hải Dương" },
    // { key: "HauGiang", value: "Hậu Giang" },
    // { key: "HaiPhong", value: "Hải Phòng" },
    // { key: "HoaBinh", value: "Hòa Bình" },
    // { key: "HungYen", value: "Hưng Yên" },
    // { key: "KhanhHoa", value: "Khánh Hòa" },
    // { key: "KienGiang", value: "Kiên Giang" },
    // { key: "KonTum", value: "Kon Tum" },
    // { key: "LaiChau", value: "Lai Châu" },
    // { key: "LamDong", value: "Lâm Đồng" },
    // { key: "LangSon", value: "Lạng Sơn" },
    // { key: "LaoCai", value: "Lào Cai" },
    // { key: "LongAn", value: "Long An" },
    // { key: "NamDinh", value: "Nam Định" },
    // { key: "NgheAn", value: "Nghệ An" },
    // { key: "NinhBinh", value: "Ninh Bình" },
    // { key: "NinhThuan", value: "Ninh Thuận" },
    // { key: "PhuTho", value: "Phú Thọ" },
    // { key: "PhuYen", value: "Phú Yên" },
    // { key: "QuangBinh", value: "Quảng Bình" },
    // { key: "QuangNam", value: "Quảng Nam" },
    // { key: "QuangNgai", value: "Quảng Ngãi" },
    // { key: "QuangNinh", value: "Quảng Ninh" },
    // { key: "QuangTri", value: "Quảng Trị" },
    // { key: "SocTrang", value: "Sóc Trăng" },
    // { key: "SonLa", value: "Sơn La" },
    // { key: "TayNinh", value: "Tây Ninh" },
    // { key: "ThaiBinh", value: "Thái Bình" },
    // { key: "ThaiNguyen", value: "Thái Nguyên" },
    // { key: "ThanhHoa", value: "Thanh Hóa" },
    // { key: "ThuaThienHue", value: "Thừa Thiên Huế" },
    // { key: "TienGiang", value: "Tiền Giang" },
    // { key: "TraVinh", value: "Trà Vinh" },
    // { key: "TuyenQuang", value: "Tuyên Quang" },
    // { key: "VinhLong", value: "Vĩnh Long" },
    // { key: "VinhPhuc", value: "Vĩnh Phúc" },
    // { key: "YenBai", value: "Yên Bái" }
]

export function isPhoneValid(phoneNumber) {
    var isValid = false;
    var phone = phoneNumber.trim();
    phone = phone.replace('(+84)', '0');
    phone = phone.replace('+84', '0');
    phone = phone.replace('0084', '0');
    phone = phone.replace(/ /g, '');
    if (phone != '') {
        var firstNumber = phone.substring(0, 2);
			if ((firstNumber == '09' || firstNumber == '08' || firstNumber == '03' || firstNumber == '05' || firstNumber == '07') && phone.length == 10) {
            if (phone.match(/^\d{10}/)) {
                isValid = true;
            }
        } else if (firstNumber == '01' && phone.length == 11) {
            if (phone.match(/^\d{11}/)) {
                isValid = true;
            }
        } 
    }
    return isValid;
}

export function isEmailValid(email) {
    var isValid = false;
    var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (regex.test(email)) {
        isValid = true;
    }
    return isValid;
}

export const DEFAULT_INSTANT_RANGE_FROM = 21600;

export const DEFAULT_INSTANT_RANGE_TO = 1209600;

export const listInstantRangeFrom = [
    { key: 21600, value: "6 tiếng tới" },
    // { key: 43200, value: "12 tiếng tới" },
    // { key: 86400, value: "24 tiếng tới" }
]

export const listInstantRangeTo = [
    { key: 604800, value: "1 tuần tới" },
    { key: 1209600, value: "2 tuần tới (Khuyến nghị)" },
    { key: 1814400, value: "3 tuần tới" },
    { key: 2419200, value: "4 tuần tới" },
]

export const DEFAULT_AVAIL_FROM = 0;

export const DEFAULT_AVAIL_TO = 12960000;

export const listAvailFrom = [
    { key: 0, value: "Hiện tại" }
]

export const listAvailTo = [
    { key: 2592000, value: "1 tháng tới" },
    { key: 5184000, value: "2 tháng tới" },
    { key: 7776000, value: "3 tháng tới (khuyến nghị)" },
    { key: 12960000, value: "5 tháng tới" }
]
 
export function convertSecondToTime(second) {

    if (second < 3600) {
        return "Hiện tại"
    }
    if (second / 3600 > 24) {
       
        return parseInt(second / (3600 * 24)) + " ngày tới";
        
    } else {
        return parseInt(second / 3600) + " giờ tới";
    }
}

export function convertTimeToRecent(timeInMilliseconds) {
    if (timeInMilliseconds < moment().valueOf()) {
        return moment(timeInMilliseconds).fromNow();
    }
    return moment(timeInMilliseconds).toNow();
}

// const AccessTradeInfo = {
//     _access_key: "Op2XU0jj7pQPbmRWiNYMJmGFVbRvLuZO",
//     getAccessTradeBaseUrl: "https://api.accesstrade.vn/v1/postbacks/conversions",
// }

export function trackOrderToAccessTrade(tripId, totalPrice, catid) {
    const trackingId = cookie.load("_aff_sid") || "";
    if (trackingId === "") return;

    window.AT.init({ "campaign_id": 623, "is_reoccur": 1, "is_lastclick": 1 });
    let accesstrade_order_info = {
        order_id: tripId,
        amount: totalPrice,
        discount: 0,
        extra__phone: "default",
        order_items: [
            {
                itemid: "default",
                quantity: 1,
                price: totalPrice,
                catid: "cps"
            }
        ]
    }
    window.AT.track_order(accesstrade_order_info);
}
export function trackCarRegisterToAccessTrade(regId) {
    const trackingId = cookie.load("_aff_sid") || "";
    if (trackingId === "") return;

    window.AT.init({ "campaign_id": 623, "is_reoccur": 1, "is_lastclick": 1 });
    let accesstrade_order_info = {
        order_id: regId,
        amount: 0,
        discount: 0,
        extra__phone: "default",
        order_items: [
            {
                itemid: "default",
                quantity: 1,
                price: 0,
                catid: "cpql"
            }
        ]
    }
    window.AT.track_order(accesstrade_order_info);
}
export function trackBizRegisterToAccessTrade(regId) {
    const trackingId = cookie.load("_aff_sid") || "";
    if (trackingId === "") return;

    window.AT.init({ "campaign_id": 897, "is_reoccur": 1, "is_lastclick": 1 });
    let accesstrade_order_info = {
        order_id: regId,
        amount: 0,
        discount: 0,
        extra__phone: "default",
        order_items: [
            {
                itemid: "default",
                quantity: 1,
                price: 0,
                catid: "cpql"
            }
        ]
    }
    window.AT.track_order(accesstrade_order_info);
}
  


export function trackOrderToOptimise(tripId, totalPrice) {
    if (!cookie.load("Optimise")) return
    const script = document.createElement("script");
    script.src = `https://track.omguk.com/2054257/e/ss/?APPID=${tripId}&MID=2054257&PID=37337&status=${totalPrice}&EX2=af_travel_first_booking`
    // For body
    document.body.appendChild(script);
    // let noscript = document.createElement("noscript");
    // const img = document.createElement("img");
    // img.src = `https://track.omguk.com/e/si/?APPID=${tripId}&MID=2054257&PID=37337&status=${totalPrice}`
    // img.border = "0"
    // img.height = "1"
    // img.width = "1"
    // noscript.appendChild(img)
    // // For body
    // document.body.appendChild(noscript);
}

export const DType = {
	"CAR_ADDR": 1,
	"CUSTOM_ADDR": 2,
	"MY_ADDR": 3,
    "AIRPORT" : 4
}

export const getAddressName = (addr) => {
	let addressName = `${addr.street}, ${addr.wardName}, ${addr.districtName}, ${addr.cityName}, ${addr.countryName}`
	return addressName
}

export const getHereAddress = (addr) => {
    if (typeof(addr) === 'string') {
        return addr;
    }
	//street, houseNumber, district, county, country, city
	let addressName = `${addr.houseNumber ? `${addr.houseNumber} ` : ''} ${addr.street ? `${addr.street},` : ''} ${addr.district ? `${addr.district}, ` : '' } ${addr.county}, ${addr.country}`
	return addressName
}


export const isEqualObj = (objA, objB) => {
// create each array of props
var aProps = Object.getOwnPropertyNames(objA);
var bProps = Object.getOwnPropertyNames(objB);

if (aProps.length != bProps.length) {
    return false;
}

for (var i = 0; i < aProps.length; i++) {
     var propName = aProps[i];          
		
		 // compare value of props
     if (objA[propName] !== objB[propName]) {             
         return false;         
     }     
}

return true; 
}  


export const isEmptyObj = (obj) => {
		for(var i in obj) return false; 
		return true;

} 


export function convertToWeekDayString(weekday){
	switch (weekday){
		case 1:
			return 'CN';
		default:
			return 'T' + weekday;
	}
}


export const RegistryType = {
	1: "Không kinh doanh",
	2: "Kinh doanh",
	3: "Grab",
	4: "Bán tải"
}

export const TypeRegBox = {
	MODEL_NOT_FOUND: 1,
	INS_NOT_FOUND: 2,
	BOOKING: 3,
    BOOKING_TNDS: 4
}

export const cancelPolicyType = {
    TIME_1: "time-1",
    TIME_2: "time-2",
    TIME_3: "time-3"
}

export function getDetailGPSStatus(status) {
    if (status === "Thiết bị đã bị rút khỏi nguồn") {
        return {
            class: "line-dot red-dot",
        }
    } else if (status === "Thiết bị đã được cấp nguồn") {
        return {
            class: "status green-dot",
        }
    } else if (status === "Xe đã tắt máy") {
        return {
            class: "status black-dot",
        }
    } else if (status === "Không thể xác định") {
        return {
            class: "status black-dot",
        }
    } else if (status === "Xe đã dừng lại") {
        return {
            class: "status gray-dot",
        }
    } else if (status === "Xe đã mở máy") {
        return {
            class: "status yellow-dot",
        }
    } else if (status === "Xe bắt đầu di chuyển") {
        return {
            class: "status green-dot",
        }
    } else if (status === "Xe đã di chuyển ngoài khu vực cho phép") {
        return {
            class: "red-dot",
        }
    } else if (status === "Xe đang di chuyển quá tốc độ cho phép") {
        return {
            class: "red-dot",
        }
    } else if (status === "Xe đang di chuyển ngoài thành phố cho phép") {
        return {
            class: "red-dot",
        }
    } else {
        return {
            class: "status green-dot",
        }
    }
}

export const compareArrays = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
};

export const getRandom = (arr, n) => {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len)
        n = len;
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

export const toggleSidebar = (boolean) => {
    return !boolean
}

export const renderTimeCreated = (time) => {
    if (moment().isSame(time, "year")) {
        return `Tham gia: ${moment(time).format("DD/MM/YYYY")}`;
    } else {
        return `Tham gia từ năm 2022`;
    }
};

export const renderNumberGreaterThan100 = (number) => {
    return number <= 100 ? number : "100+";
}

export const PromoModes = {
    DEFAULT: 0,
    CODE: 1,
}